import useTypedSelector from "@hooks/useTypedSelector";
import { useEffect, useRef } from "react";

/** Removes #app-loading-skeleton when Redux hides it. */
const AppLoadingSkeletonRemover = () => {
  const isVisible = useTypedSelector((s) => s.ui.appLoadingSkeletonVisible);
  const isRemoved = useRef(false);

  useEffect(() => {
    if (isRemoved.current || isVisible) return;
    const el = document.getElementById("app-loading-skeleton");
    if (!el) return;
    el.classList.add("hide-loading-skeleton");
    const removeSkeletonTimer = setTimeout(() => {
      el.remove();
      isRemoved.current = true;
      // to make sure the skeleton loads a bit before removing
    }, 300);
    return () => clearTimeout(removeSkeletonTimer);
  }, [isVisible]);

  return null;
};
export default AppLoadingSkeletonRemover;
